import { render } from "./InputSwitch.vue?vue&type=template&id=a3d53fd6&ts=true"
import script from "./InputSwitch.vue?vue&type=script&lang=ts"
export * from "./InputSwitch.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\vue_test\\form-gpt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__